import { relativeDate } from 'libs/utils/date';
export const DOMAIN_SELECTED_COOKIE = 'domain_selected';
export const DOMAIN_SELECTED_COOKIE_EXPIRATION_DATE = relativeDate({
  years: 20
}); // matches rails's `cookie.permanent`